import type * as UDM from "@busbud/int-schemas/udm";

import type { SelectedSeatsBySegment } from "@app/modules/results/hooks/use-navigation";

import { getSeatById } from "../vehicle";

const EMPTY_MAP = new Map<string, UDM.SeatCell[]>();

const getSelectedSeatsFromQsForSegmentId = (
  selected_seats_from_qs: SelectedSeatsBySegment,
  segment_id: string
): string[] => {
  const selected_seats = selected_seats_from_qs.find(
    segment_seats => !!segment_seats?.[segment_id]
  );

  return selected_seats?.[segment_id] || [];
};

export const getValidSeatsForVehicles = (
  selected_seats_from_qs: SelectedSeatsBySegment,
  vehicle_layouts: Record<string, UDM.Vehicle["layout"]>
) => {
  if (selected_seats_from_qs.length === 0) {
    return EMPTY_MAP;
  }

  const segment_seat_cells = new Map<string, UDM.SeatCell[]>();

  const are_all_seats_valid = Object.keys(vehicle_layouts).every(segment_id => {
    const vehicle_layout = {
      layout: vehicle_layouts[segment_id]
    } as UDM.Vehicle;

    const selected_seats = getSelectedSeatsFromQsForSegmentId(
      selected_seats_from_qs,
      segment_id
    );

    return selected_seats.every((seat_id: string) => {
      const seat = getSeatById(vehicle_layout, seat_id);

      if (!seat || seat.availability === false) {
        return false;
      }

      const valid_seats = segment_seat_cells.get(segment_id) || [];
      segment_seat_cells.set(segment_id, [...valid_seats, seat]);

      return true;
    });
  });

  return are_all_seats_valid ? segment_seat_cells : EMPTY_MAP;
};
